import * as firebase from 'firebase';

export const FETCH_BLOGS = 'fetch_blogs';
export const FETCH_BLOGS_SUCCESS = 'fetch_blogs_success';

export const FETCH_BLOG = 'fetch_blog';
export const FETCH_BLOG_SUCCESS = 'fetch_blog_success';

export const ADD_BLOG = 'add_blog';
export const ADD_BLOG_SUCCESS = 'add_blog_success';
export const ADD_BLOG_FAIL = 'add_blog_fail';

export const UPDATE_BLOG = 'update_blog';
export const UPDATE_BLOG_SUCCESS = 'update_blog_success';
export const UPDATE_BLOG_FAIL = 'update_blog_fail';

export const DELETE_BLOG = 'delete_blog';
export const DELETE_BLOG_SUCCESS = 'delete_blog_success';
export const DELETE_BLOG_FAIL = 'delete_blog_fail';

export function fetchAllBlogs() {
    const blogsRef = firebase.database().ref('blogs');

    return (dispatch) => {
        dispatch({ type: FETCH_BLOGS });

        blogsRef.on('value', (snapshot) => {

            if (snapshot) {

                let rawBlogs = {};
                snapshot.forEach(rawBlog => {
                    rawBlogs[rawBlog.key] = { ...rawBlog.val(), id: rawBlog.key };
                });

                dispatch({
                    type: FETCH_BLOGS_SUCCESS,
                    payload: rawBlogs
                });

            } else {
                console.log('No blogs in db!');
            }
        });
    };
}

export function fetchBlog(id, callback) {

    const blogRef = firebase.database().ref('blogs').child(id);

    return dispatch => {
        dispatch({ type: FETCH_BLOG });

        blogRef.once('value')
            .then(snapshot => {

                let blog = snapshot.val();

                if (callback) {
                    callback(blog);
                }

                if (blog) {
                    dispatch({
                        type: FETCH_BLOG_SUCCESS,
                        payload: { blog: { ...blog, id: id }, id: id }
                    });
                }
            })
            .catch(error => {
                console.log(error);

                if (callback) {
                    callback(null);
                }
            });
    }
}

export function addBlog({ blog, coverImage }, callback) {

    return (dispatch) => {

        dispatch({ type: ADD_BLOG });

        const blogRef = firebase.database().ref('blogs').push();

        firebase.database.ServerValue.TIMESTAMP

        const updateBlog = {
            ...blog,
            createdAt: firebase.database.ServerValue.TIMESTAMP,
            image_name: `${blogRef.key}.jpg`
        };

        blogRef.set(updateBlog, error => {

            if (error) {
                dispatch({
                    type: ADD_BLOG_FAIL,
                    payload: error.message
                });
            } else {
                dispatch({
                    type: ADD_BLOG_SUCCESS
                });
            }

            if (callback) {
                callback(error);
            }
        });
    };
}

export function updateBlog({ blog, coverImage, id }, callback) {

    return (dispatch) => {

        dispatch({ type: UPDATE_BLOG });

        // step 1 upload image
        if (coverImage.originFileObj) {

            performUpload(coverImage.originFileObj, id, (progress) => {
                console.log('Upload is ' + progress + '% done');
            }, (downloadURL) => {

                // image_paths

                const blogRef = firebase.database().ref('blogs').child(id);

                const updatedBlog = {
                    ...blog,
                    updatedAt: firebase.database.ServerValue.TIMESTAMP,
                    cover_path: downloadURL
                };

                blogRef.update(updatedBlog, error => {

                    if (error) {
                        dispatch({
                            type: UPDATE_BLOG_FAIL,
                            payload: error.message
                        });
                    } else {
                        dispatch({
                            type: UPDATE_BLOG_SUCCESS
                        });
                    }

                    if (callback) {
                        callback(error);
                    }
                });
            });
        }
    };
}

export function deleteBlog(id, callback) {

    return (dispatch) => {

        dispatch({ type: DELETE_BLOG });

        const blogRef = firebase.database().ref('blogs').child(id);
        blogRef.remove()
            .then(() => {

                dispatch({ type: DELETE_BLOG_SUCCESS });

                if (callback) {
                    callback(true);
                }
            })
            .catch(error => {

                dispatch({
                    type: DELETE_BLOG_FAIL,
                    payload: error.message
                });

                if (callback) {
                    callback(false);
                }
            });
    };
}

function performUpload(file, blogId, progressCallback, finishCallback) {

    console.log(file);

    // get file extensions
    // put it in file name
    // also put it in database-> image_name
    const extension = file.name.split('.').pop();

    // separated covers
    const bucketRef = firebase.storage().ref().child('public/images/blogs/covers');
    const fileRef = bucketRef.child(`${blogId}.${extension}`);
    let uploadTask = fileRef.put(file);

    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, (snapshot) => {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

        if (progressCallback) {
            progressCallback(progress);
        }

        switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
                console.log('Upload is paused');
                break;
            case firebase.storage.TaskState.RUNNING: // or 'running'
                // console.log('Upload is running');
                break;
        }
    }, (error) => {

        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        switch (error.code) {
            case 'storage/unauthorized':
                // User doesn't have permission to access the object
                break;

            case 'storage/canceled':
                // User canceled the upload
                break;

            case 'storage/unknown':
                // Unknown error occurred, inspect error.serverResponse
                break;
        }

        if (finishCallback) {
            finishCallback(null, error);
        }

    }, () => {
        // Upload completed successfully, now we can get the download URL
        const downloadURL = uploadTask.snapshot.downloadURL;

        if (finishCallback) {
            finishCallback(downloadURL);
        }
        // addFilePath(sessionId, file.name, fileRef.fullPath);

        // dispatch({
        //     type: UPLOAD_FILE_COMPLETED,
        //     payload: file.name
        // });

        // const nextIndex = index + 1;
        // // console.log(`index: ${nextIndex} - lenght: ${files.length}`);

        // if (nextIndex < files.length) {
        //     // upload next file
        //     performUpload(files, nextIndex, sessionId, dispatch, callback);
        // } else {
        //     // upload done!!
        //     if (callback) {
        //         callback();
        //     }
        // }
    });
}


// WEBPACK FOOTER //
// ./src/actions/Blog.js